var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47954 10.0714C2.18172 10.2561 2 10.5854 2 10.9404V20.9823C2 21.5443 2.44772 22 3 22H7V18.438C7 17.0328 8.11929 15.8936 9.5 15.8936C10.8807 15.8936 12 17.0328 12 18.438V22H16C16.5523 22 17 21.5443 17 20.9823V10.9404C17 10.5854 16.8183 10.2561 16.5205 10.0714L10.5409 6.36211C9.90167 5.96556 9.09833 5.96556 8.45907 6.36211L2.47954 10.0714Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.292 22H21C21.5523 22 22 21.5443 22 20.9823V6.28507C22 5.93166 21.8198 5.60354 21.5241 5.41832L16.5482 2.30194C15.9054 1.89935 15.0946 1.89935 14.4518 2.30194L10.5957 4.717C10.8466 4.80116 11.0902 4.91501 11.3216 5.05854L17.3012 8.76782C18.0457 9.22968 18.5 10.053 18.5 10.9404V20.9823C18.5 21.3441 18.4258 21.6883 18.292 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt7);
export default __webpack_public_path__ + "static/media/apartments-alt-7.39c5a7f844b5e8638701521d7c65b833.svg";
export { ForwardRef as ReactComponent };